import { render, staticRenderFns } from "./customer_360.vue?vue&type=template&id=5d5c192f&scoped=true&"
import script from "./customer_360.vue?vue&type=script&lang=js&"
export * from "./customer_360.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c192f",
  null
  
)

export default component.exports